import React from 'react'
import {connect} from 'react-redux'
import {getCombatantIdFromSelectingString} from '../get-combatant-id-from-selecting-string.js'
import {setBattleValue} from '../../redux-actions/battle-actions.js'
import SubmissionHomeMenu from './SubmissionHomeMenu.js'
import SubmissionListViewMenu from './SubmissionListViewMenu'
import {isSubmissionMenuOpen} from './is-submission-menu-open'
import ArenaSubmissionMenuBackButton from './ArenaSubmissionMenuBackButton'
import SubmissionTargetMenu from './SubmissionMenu/SubmissionTargetMenu'
import store from '../../init/store.js'
import {submitAction} from '../lifecycle/submit-action.js'
import audioManager from '../../_audio/audio-manager.js'
import './ArenaSubmission.css'

/** THIS IS JUST FOR DEV TESTING. I ASSUME THIS WILL BE REPLACED WITH A TRUE MENU IMPLEMENTATION */
class ArenaSubmissionMenu extends React.Component {

  renderRelevantForm() {

    //Final Step: Action is deployed
    if (this.props.arenaSubmissionIsSubmitted) {
      return null
    }

    // //Step 3: might get a TIMING CHALLENGE
    //TODO: leaving this here for a bit for reference in case we want to put this back
    // if (
    //   this.props.arenaSubmissionMenuAction && //have action loaded up
    //   this.props.arenaSubmissionMenuAction.hasTimedHitBonusAvailable && //that has a timed opportunity
    //   this.props.arenaSubmissionMenuTargets //and target model is loaded up
    // ) {
    //   return <TimingChallenge />
    // }

    const viewId = this.props.arenaMenuSnapshot.viewId;

    //Step 2: pick a target
    if (viewId === "targetsView") {
      return (
        <SubmissionTargetMenu
          vW={this.props.vW}
          arenaSubmissionMenuAction={this.props.arenaSubmissionMenuAction}
          arenaMenuSnapshot={this.props.arenaMenuSnapshot}
        />
      )
    }

    //If we are in a transition state (rootView), don't render any menu UI
    //This is below TimingChallenge because we might have the TimingChallenge up
    if (viewId === "rootView") {
      return null;
    }

    if (viewId === "specialsView" || viewId === "itemsView" || viewId === "supersView") {
      return <SubmissionListViewMenu />
    }

    //Step 1: pick an action
    return <SubmissionHomeMenu />;
  }

  renderBackButton() {

    const viewId = this.props.arenaMenuSnapshot.viewId;


    if (viewId === "specialsView" || viewId === "itemsView" || viewId === "supersView") {
      //Return a back button with the list-view Back option specified. All ListViews share this.
      return <ArenaSubmissionMenuBackButton optionId="listview-back" menuModel={this.props.arenaMenuSnapshot} />
    }

    if (viewId === "targetsView") {
      //Return a back button with the targeting step Back option specified
      return <ArenaSubmissionMenuBackButton optionId="target-back" menuModel={this.props.arenaMenuSnapshot} />
    }

    //Otherwise, no Back button
    return null;
  }


  getStyle() {
    let baseStyle = {
      color: "#eee",
    };

    //TODO TODO TODO: This stuff will likely move to the ArenaMainLaptopContainer
    //TODO: then this stuff can go away

    //Get Desktop Styles
    if (this.props.viewportMode === "landscape") {
      return {
        ...baseStyle,
        // right: this.props.vW * 2,
        // width: this.props.vW * 36,
      }
    }
    //Otherwise assume Mobile
    return {
      ...baseStyle,
      // left: 0,
      // right: 0,
    }

  }

  render() {

    if (!isSubmissionMenuOpen()) { //extracted this stuff so other things could use it.
      return null;
    }
    const {combatantSelectingAction} = this.props;
    const useCombId = getCombatantIdFromSelectingString(combatantSelectingAction);


    //Style the top bar
    const topBarStyle = {
      // paddingLeft: "4em",
      // paddingRight: "4em",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "0.5em",
      fontSize: "0.5em",
      height: "4em",
      borderBottom: "0.3em solid rgba(255,255,255,0.1)"
    };
    const ppStyle = {
      opacity: "rgba(255,255,255,0.5)",
    };

    const mainContentStyle = {
      // paddingLeft: "4em",
      // paddingRight: "4em",
    };

    //Get selecting combatant
    const selectingCombatantModel = this.props.combatants[useCombId];

    return (
      <div style={this.getStyle()}>
        <div style={topBarStyle}>
          <span>
            {this.renderBackButton()}
          </span>
          <span>
            <span style={{...ppStyle, marginRight:"2em"}}>HP {selectingCombatantModel.hp}/{selectingCombatantModel.maxHp}</span>
            <span style={ppStyle}>PP {selectingCombatantModel.pp}/{selectingCombatantModel.maxPp}</span>
          </span>
        </div>
        <div style={mainContentStyle}>
          {this.renderRelevantForm()}
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {

    vW: state.global.vW,
    viewportMode: state.global.viewportMode,
    combatantSelectingAction: state.battle.combatantSelectingAction,
    arenaSubmissionMenuCombatantIdLock: state.battle.arenaSubmissionMenuCombatantIdLock,
    battlePlayerIds: state.battle.battlePlayerId, //The array of player controlled combatantIds
    combatants: state.battle.combatants,

    //Arena Submission progress
    arenaSubmissionMenuAction: state.battle.arenaSubmissionMenuAction,
    //arenaSubmissionMenuCaster: state.battle.arenaSubmissionMenuCaster, //can be computed
    arenaSubmissionMenuTargets: state.battle.arenaSubmissionMenuTargets,
    arenaSubmissionIsSubmitted: state.battle.arenaSubmissionIsSubmitted, //final flag
    arenaMenuSnapshot: state.battle.arenaMenuSnapshot
  }
})(ArenaSubmissionMenu)


/* Submit all data into the cycle */
/* Timing challenge component should do this on completion */
export function arenaSubmitFinalAction() {

  setBattleValue({
    arenaSubmissionIsSubmitted: true,
    arenaSubmissionMenuCombatantIdLock: null, //CLEAR THE LOCK OUT
  });

  //Pull data needed for submission
  const {
    //action data
    arenaSubmissionMenuAction,

    //caster data
    combatants,
    combatantSelectingAction,

    //targets data
    arenaSubmissionMenuTargets
  } = store.getState().battle;


  //Play sound effect (if the TimingChallenge did not already do it, like for generic attack)
  //TODO: The exact SFX firing might get reworked when implementing the actual design of the Submission Menu
  //if (arenaSubmissionMenuAction.actionMeta.actionId !== "attack_generic-attack") {
    //Play regular SFX
    audioManager.playSfx("sfx_submitAction")
  //}

    //Submit!
    submitAction(
      arenaSubmissionMenuAction,
      combatants[getCombatantIdFromSelectingString(combatantSelectingAction)],
      arenaSubmissionMenuTargets
    )

}



// WEBPACK FOOTER //
// ./src/battle/ArenaView/ArenaSubmissionMenu.js